import { apiSlice } from 'store/slices/api/api-slice';
import { ProductImagesRequest } from 'types/product/product';

export const importTradeDataApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        productImageUpdate: builder.mutation<void, ProductImagesRequest>({
            query: (productImagesRequest: ProductImagesRequest) => ({
                url:
                    `/product/add-product-image/` +
                    productImagesRequest.productId,
                method: 'POST',
                body: productImagesRequest.image,
                header: {},
            }),
        }),
    }),
});

export const { useProductImageUpdateMutation } = importTradeDataApiSlice;
